import { getCurrentInstance } from 'vue'

export function useRouter() {
    const vm = getCurrentInstance()
    if (!vm) throw new Error('useRouter debe ser llamado dentro de setup()')
    return vm.proxy.$router
}

export function useRoute() {
    const vm = getCurrentInstance()
    if (!vm) throw new Error('useRoute debe ser llamado dentro de setup()')
    return vm.proxy.$route
}